// extracted by mini-css-extract-plugin
export var smoothScrolling = "styles-module--smoothScrolling--0731a";